/* eslint-disable camelcase */
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import { TooQuoteSnapshot, TooQuoteInputSnapshot } from '../../models';
import api, { rawClient } from '../api';

const createQuote = (
    insuranceId: string,
    input: TooQuoteInputSnapshot
): Promise<TooQuoteSnapshot> =>
    api.request<TooQuoteSnapshot>({
        url: `${getBackVersion()}/agent/insurances/residential/too/${insuranceId}/quote`,
        method: 'POST',
        action: 'TOO_INSURANCE_QUOTE',
        data: decamelizeKeys(input),
    });

const activateQuote = (
    insuranceId: string,
    quoteId: string
): Promise<TooQuoteSnapshot> =>
    api.request<TooQuoteSnapshot>({
        url: `${getBackVersion()}/agent/insurances/residential/too/${insuranceId}/quote/${quoteId}`,
        method: 'PATCH',
    });

const downloadQuote = (insuranceId: string): Promise<void> => {
    return rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/agent/insurances/residential/too/${insuranceId}/quote_download`,
    });
};

export { createQuote, activateQuote, downloadQuote };
